export default "__VITE_PUBLIC_ASSET__169d1174__"